import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../ui/services/auth/auth.service';

export const permissionsGuard: CanActivateFn = async route => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const userPermissions = await authService.getUserPermissions();
  const permission = route.data['permission'];

  if (Array.isArray(permission)) {
    const hasAccess = permission.some(p => userPermissions.includes(p));
    !hasAccess && router.navigate(['/']);
    return hasAccess;
  }

  const hasAccess = userPermissions.includes(permission);
  !hasAccess && router.navigate(['/']);
  return hasAccess;
};
